import { render, staticRenderFns } from "./BioSocialLinksGrid.vue?vue&type=template&id=980682bc&scoped=true&"
import script from "./BioSocialLinksGrid.vue?vue&type=script&lang=js&"
export * from "./BioSocialLinksGrid.vue?vue&type=script&lang=js&"
import style0 from "./BioSocialLinksGrid.vue?vue&type=style&index=0&id=980682bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980682bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VIcon})
